// removed by extract-text-webpack-plugin
module.exports = {"physical-tree-wrapper":"_3AuycSwXyLXuY6VbAjNEGW_0","obj-list-wrapper":"_1kZqG-_4ALGE2WaTVvOK0R_0"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"sourceMap":true,"localIdentName":"[hash:base64]_0","importLoaders":true,"modules":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-07bfa3ca","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/settings/basic/LogicalGroupSettings/LogicalGroupConfigView.vue
// module id = 40jn
// module chunks = 75